import React, { useState } from 'react';
import { StreamlineIcon } from '@rsos/assets/icons';
import HoveredButton from '@rsos/components/capstone/HoveredButton';
import usePortalType from '@rsos/utils/usePortalType';
import IndoorLocation from '../IndoorLocation';
import VerticalUncertainty from '../VerticalUncertainty';
import { handleCopy } from '../helpers/handleCopy';
import {
  RowBox,
  LeftText,
  MiddleText,
  CopyColumnBox,
  IconWrapper,
} from '../styles/common.styles';

const Altitude = ({
  altitude,
  indoorLocation,
  altitudeUncertaintyRadius,
  isHoverable,
  irpVersion,
  payloadID,
  requestID,
}) => {
  const { portalType } = usePortalType();

  const [isCopied, setIsCopied] = useState();
  if (!altitude) return null;

  const altitudeValue = parseFloat(altitude).toFixed(1);
  const verticalUncertaintyValue = altitudeUncertaintyRadius
    ? `, Vertical Uncertainty: ${Number(altitudeUncertaintyRadius).toFixed(1)}`
    : '';
  const indoorValue = indoorLocation
    ? `, Indoor Location: ${indoorLocation}`
    : '';

  const onClick = () => {
    handleCopy({
      value: `Altitude: ${altitudeValue} ${indoorValue} ${verticalUncertaintyValue}`,
      name: 'Altitude, Indoor Location and Vertical Uncertainty',
      irpVersion,
      payloadID,
      requestID,
      portalType,
      onStart: () => {
        setIsCopied(true);
      },
      onEnd: () => {
        setIsCopied(false);
      },
    });
  };
  return (
    <RowBox br="5px" isHoverable={isHoverable} copied={isCopied}>
      <RowBox overflow="hidden">
        <IconWrapper>
          <StreamlineIcon />
        </IconWrapper>
        <CopyColumnBox overflow="hidden">
          <RowBox overflow="hidden">
            <RowBox data-name="altitude">
              <LeftText>Altitude:&nbsp;</LeftText>
              <MiddleText data-name="altitude-text">
                {parseFloat(altitude).toFixed(1)}m&nbsp;
              </MiddleText>
            </RowBox>
            <IndoorLocation indoorLocation={indoorLocation} />
          </RowBox>
          <VerticalUncertainty
            altitudeUncertaintyRadius={altitudeUncertaintyRadius}
          />
        </CopyColumnBox>
      </RowBox>
      {isHoverable && (
        <HoveredButton onClick={onClick} withIcon isCopied={isCopied} />
      )}
    </RowBox>
  );
};

export default Altitude;
